import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Heading,
  Input,
  Text,
  VStack,
  Button,
  Avatar,
  Image,
  InputGroup,
  InputLeftElement,
  IconButton,
  useToast,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Checkbox,
  ModalFooter,
  useDisclosure,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  Badge,
} from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { io } from "socket.io-client";
import { format, isToday, isValid, parseISO } from "date-fns";
import chatlogo from "../../../assets/chatImage.png";
import { useSelector } from "react-redux";
import { FiMoreVertical, FiPaperclip, FiTrash2, FiX } from "react-icons/fi";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import AdminSidebar from "../../../Components/AdminSidebar";
import Navbar from "../../../Components/Navbar";

const socket = io("https://develop-project-360.onrender.com");

const AdminChat = () => {
  const globalState = useSelector((store) => store.authentication.users);
  //console.log("empid", globalState);
  const [searchQuery, setSearchQuery] = useState("");
  const [userId, setUserId] = useState(globalState?.id);
  const [chatList, setChatList] = useState([]);
  //console.log("userIdInvitation", userId);
  const [selectedChat, setSelectedChat] = useState(null);
  //console.log("selectedChat", selectedChat);
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState("");
  //console.log("messages", messages);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const attendance = useSelector((state) => state.AppReducer.attendances);
  //console.log("attt",attendance)
  const getUserStatusColor = (employeeId) => {
    const userAttendance = attendance
      ?.filter((att) => att.employee_id === employeeId)
      ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0]; // Get the latest

    if (!userAttendance) return "gray";

    return userAttendance.breakIn === false ? "green" : "red";
  };

  // console.log("status",getUserStatusColor)

  useEffect(() => {
    const fetchChats = async () => {
      try {
        const [privateRes, groupRes] = await Promise.all([
          fetch(`https://develop-project-360.onrender.com/messages/${userId}`),
          fetch(`https://develop-project-360.onrender.com/group/${userId}`),
        ]);

        const privateChats = await privateRes.json();
        const groupChats = await groupRes.json();

        const formattedChats = privateChats.chats.map((g) => ({
          id: g.user._id,
          name: g.user.sudo_name,
          isGroup: false,
          path: g.user.path,
          lastMessage: g.messages[0].text,
          lastMessageAt: g.messages[0].createdAt,
          messages: g.messages,
        }));

        const formattedGroups = groupChats.chats.map((g) => ({
          id: g._id,
          name: g.name,
          isGroup: true,
          path: g.profileImage,
          lastMessage: g.lastMessage,
          lastMessageAt: g.lastMessageAt,
          messages: [],
          members: g.members,
          admin: g.admin,
        }));
        //console.log("formattedChats", formattedChats);
        setChatList([...formattedChats, ...formattedGroups]);
      } catch (err) {
        console.error("Error fetching chat list", err);
      }
    };

    fetchChats();
  }, [userId]);

  useEffect(() => {
    if (!socket || !selectedChat) return;

    const handlePrivateMsg = ({ sender, message }) => {
      if (
        selectedChat &&
        !selectedChat.isGroup &&
        (sender === selectedChat.id || message.receiver === selectedChat.id)
      ) {
        setMessages((prev) => [...prev, message]);
      }
    };

    const handleGroupMsg = ({ sender, message }) => {
      if (
        selectedChat &&
        selectedChat.isGroup &&
        message.groupId === selectedChat.id
      ) {
        setMessages((prev) => [...prev, message]);
      }
    };

    socket.on("newMessage", handlePrivateMsg);
    socket.on("newGroupMessage", handleGroupMsg);

    return () => {
      socket.off("newMessage", handlePrivateMsg);
      socket.off("newGroupMessage", handleGroupMsg);
    };
  }, [selectedChat]);

  useEffect(() => {
    if (!userId) return;

    // Join user's own room for private messages
    socket.emit("joinRoom", userId);
  }, [userId]);

  const handleChatSelect = async (chat) => {
    setSelectedChat(null); // optionally clear old selection immediately
    setMessages([]); // clear current messages in UI
    //console.log("chat", chat);
    if (chat.isGroup) {
      socket.emit("joinGroup", chat.id);

      try {
        const res = await fetch(
          `https://develop-project-360.onrender.com/group/messages/${chat.id}`
        );
        const data = await res.json();
        //console.log("data",data)

        const updatedChat = {
          ...chat,
          messages: data || [], // fallback to empty array
        };

        setSelectedChat(updatedChat);
        setMessages(updatedChat.messages);
      } catch (err) {
        console.error("Failed to fetch group messages", err);
      }
    } else {
      setSelectedChat(chat);
      setMessages(chat.messages);
    }
  };
  const [selectedFiles, setSelectedFiles] = useState([]);
  const toast = useToast();

  // Add files handler
  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    const totalFiles = selectedFiles.length + newFiles.length;

    if (totalFiles > 10) {
      toast({
        title: "Maximum 10 files allowed.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setSelectedFiles((prev) => [...prev, ...newFiles]);
  };

  // Remove file handler
  const removeFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSendMessage = async () => {
    if (!newMsg.trim() && selectedFiles.length === 0) return;

    const formData = new FormData();
    formData.append("sender", userId);

    if (selectedFiles.length) {
      selectedFiles.forEach((file) => {
        formData.append("files", file);
      });

      if (!newMsg.trim()) {
        // Only files, no message
        const fileNames = selectedFiles.map((file) => file.name).join(", ");
        formData.append("message", `📎 File Attachment: ${fileNames}`);
      } else {
        // Message + attachments
        formData.append("message", newMsg);
      }
    } else {
      // Only message
      formData.append("message", newMsg);
    }

    let endpoint = "";
    if (selectedChat.isGroup) {
      formData.append("groupId", selectedChat.id);
      endpoint = "https://develop-project-360.onrender.com/group/send";
    } else {
      formData.append("receiver", selectedChat.id);
      endpoint = "https://develop-project-360.onrender.com/send";
    }

    try {
      const res = await fetch(endpoint, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (data.success) {
        const newMessage = data.data;
        setNewMsg("");
        setSelectedFiles([]);

        setMessages((prev) => [...prev, newMessage]);

        if (selectedChat.isGroup) {
          socket.emit("sendGroupMessage", {
            sender: userId,
            groupId: selectedChat.id,
            message: newMessage,
          });
        } else {
          socket.emit("sendMessage", {
            sender: userId,
            receiver: selectedChat.id,
            message: newMessage,
          });
        }
      }
    } catch (err) {
      console.error("Error sending message", err);
    }
  };

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { register, handleSubmit, reset, setValue } = useForm();
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  //console.log("selusers", selectedUsers);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const params = globalState.adminId
          ? { adminId: globalState.adminId }
          : { companyId: globalState.companyId };

        const res = await axios.get(
          "https://develop-project-360.onrender.com/getUserById",
          {
            params,
          }
        );
        setUsers(res.data);
      } catch (error) {
        console.error("Failed to fetch users", error);
      }
    };

    fetchUsers();
  }, [globalState.adminId, globalState.companyId]);

  const handleUserToggle = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  const handleFiles = (e) => {
    const files = Array.from(e.target.files);
    setValue("files", files); // Hook form manually set
    const previewUrl = files[0] ? URL.createObjectURL(files[0]) : null;
    setPreview(previewUrl);
  };

  const onSubmit = async (data) => {
    if (!data.files || data.files.length === 0) {
      toast({
        title: "Please upload a group icon",
        status: "warning",
        duration: 3000,
      });
      return;
    }

    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("admin", userId);

    // Add the creator (admin) as a member too
    formData.append("members", userId);

    // Add other selected users
    selectedUsers.forEach((id) => {
      if (id !== userId) {
        formData.append("members", id);
      }
    });

    data.files.forEach((file) => formData.append("files", file));

    try {
      const res = await axios.post(
        "https://develop-project-360.onrender.com/group/create",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast({
        position: "top",
        title: "Group Created!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      reset();
      setSelectedUsers([]);
      setPreview(null);
      onClose();
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (err) {
      toast({
        position: "top",
        title: "Error creating group",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const [groupModal, setGroupModal] = useState(false);
  const handleViewDetails = (selectedChat) => {
    setSelectedChat(selectedChat);
    setGroupModal(true);
  };

  const getUserDetails = (id) => users.find((user) => user._id === id);
  const getFileUrl = (path) =>
    `https://develop-project-360.onrender.com/uploads/${path}`;
  const getImageUrl = (path) =>
    `https://develop-project-360.onrender.com/uploads/${path}`;

  const handleDeleteGroup = async (groupId) => {
    try {
      const response = await axios.delete(
        "https://develop-project-360.onrender.com/delete-group",
        {
          data: { groupId },
        }
      );

      if (response.data.success) {
        toast({
          title: "Group deleted.",
          description: response.data.message,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setGroupModal(false); // close modal
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    } catch (error) {
      toast({
        title: "Error deleting group.",
        description: error.response?.data?.message || "Something went wrong.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleRemoveMember = async (memberIdToRemove) => {
    try {
      const response = await fetch(
        "https://develop-project-360.onrender.com/remove-group-members",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            groupId: selectedChat._id || selectedChat.id,
            memberIds: [memberIdToRemove],
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setSelectedChat((prev) => ({
          ...prev,
          members: data.group.members.map((m) => m._id || m),
        }));

        toast({
          title: "Member removed",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error(data.message || "Failed to remove member");
      }
    } catch (error) {
      console.error("Remove member error:", error);
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleDeleteMessage = async (messageId) => {
    try {
      const res = await fetch(
        "https://develop-project-360.onrender.com/delete-message",
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ messageId }),
        }
      );

      const data = await res.json();

      if (data.success) {
        setMessages((prev) => prev.filter((msg) => msg._id !== messageId));
        toast({
          title: "Message deleted",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error(data.message || "Unable to delete message");
      }
    } catch (err) {
      console.error("Delete message error", err);
      toast({
        title: "Error",
        description: err.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const [invitations, setInvitations] = useState([]);

  const fetchInvitations = async () => {
    try {
      const res = await axios.get(
        `https://develop-project-360.onrender.com/invitations/sender/${userId}`
      );
      if (res.data.success) {
        setInvitations(res.data.invitations);
      }
    } catch (err) {
      console.error("Error fetching invitations:", err);
    }
  };

  useEffect(() => {
    if (userId) fetchInvitations();
  }, [userId]);
  const handleInvite = async (receiverId) => {
    try {
      const res = await axios.post(
        "https://develop-project-360.onrender.com/invite",
        {
          sender: userId,
          receiver: receiverId,
        }
      );
      if (res.data.success) {
        toast({
          title: "Invitation Sent",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        fetchInvitations();
      }
    } catch (err) {
      console.error("Error sending invitation:", err);
    }
  };

  const getInvitationStatus = (user) => {
    const userId = user._id;

    // Find any invitation involving this user
    const invitation = invitations.find(
      (inv) =>
        (inv.sender === globalState?.id && inv.receiver === userId) ||
        (inv.receiver === globalState?.id && inv.sender === userId)
    );

    //console.log("inv",invitation)

    if (!invitation) return "none";

    const isSender = invitation.sender === globalState?.id;
    const isReceiver = invitation.receiver === globalState?.id;

    if (invitation.status === "accepted") return "accepted";

    if (invitation.status === "pending") {
      if (isSender) return "pending"; // You sent it
      if (isReceiver) return "respond"; // You received it
    }

    if (invitation.status === "rejected") {
      if (isSender) return "rejected"; // You sent and got rejected — can re-invite
      return "none"; // You received and rejected — no UI for now
    }

    return "none";
  };

  const filteredUsers = users.filter(
    (u) =>
      u._id !== userId &&
      u.sudo_name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  //console.log("vvdvd",filteredUsers)
  const handleAcceptInvitation = async (invitationId) => {
    try {
      const response = await axios.post(
        "https://develop-project-360.onrender.com/invite/accept",
        {
          invitationId,
        }
      );

      if (response.data.success) {
        toast({
          title: "Invitation Accepted",
          description: "You have accepted the invitation.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // Optionally re-fetch invitations list or update local state
        //fetchInvitations(); // or update invitations state manually
        setInvitations((prev) =>
          prev.map((inv) =>
            inv._id === invitationId ? { ...inv, status: "accepted" } : inv
          )
        );
      }
    } catch (error) {
      console.error("Error accepting invitation:", error);
      toast({
        title: "Error",
        description: "Failed to accept the invitation.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleRejectInvitation = async (invitationId) => {
    try {
      const response = await axios.post(
        "https://develop-project-360.onrender.com/invite/reject",
        {
          invitationId,
        }
      );

      if (response.data.success) {
        toast({
          title: "Invitation Rejected",
          description: "You have rejected the invitation.",
          status: "info",
          duration: 3000,
          isClosable: true,
        });

        // Re-fetch invitations list or update local state
        //fetchInvitations();
        setInvitations((prev) =>
          prev.map((inv) =>
            inv._id === invitationId ? { ...inv, status: "rejected" } : inv
          )
        );
      }
    } catch (error) {
      console.error("Error rejecting invitation:", error);
      toast({
        title: "Error",
        description: "Failed to reject the invitation.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const [selectedNewMembers, setSelectedNewMembers] = useState([]);
  //console.log("selNewMem",selectedNewMembers)

  const handleUserToggleForNewMembers = (userId) => {
    setSelectedNewMembers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  const handleAddMembers = async () => {
    try {
      const res = await axios.put(
        "https://develop-project-360.onrender.com/update-members",
        {
          groupId: selectedChat.id,
          memberIds: selectedNewMembers,
          action: "add",
        }
      );

      if (res.data.success) {
        setSelectedChat((prev) => ({
          ...prev,
          members: res.data.group.members.map((m) => m._id || m),
        }));
        // Clear selection
        setSelectedNewMembers([]);
        // Optionally update chat UI
        //setSelectedChat(res.data.group);
        toast({
          title: "Members added successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Add members error:", error);
      toast({
        title: "Error adding members",
        description: error?.response?.data?.message || "Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex>
      <AdminSidebar />
      <Box
        pl={{ base: "none", md: "10" }}
        pt={{ base: "none", md: "10" }}
        w="80%"
      >
        <Navbar />
        <Heading size={"md"} mt={4}></Heading>

        <Flex justifyContent="space-between">
          <Breadcrumb
            spacing="8px"
            mt={4}
            mb={6}
            separator={<ChevronRightIcon color="gray.500" />}
          >
            <BreadcrumbItem>
              <BreadcrumbLink href="/admin">Dashboard</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <BreadcrumbLink href="#">Chat</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Button colorScheme="blue" size={"xs"} onClick={onOpen}>
                Create Group
              </Button>
            </BreadcrumbItem>
          </Breadcrumb>
          <Box position="relative" w="30%">
            <Input
              placeholder="Search users..."
              focusBorderColor="green.400"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            {/* Show filtered users in absolute dropdown */}
            {searchQuery.trim() !== "" && (
              <Box
                position="absolute"
                top="45px"
                left="0"
                right="0"
                bg="white"
                zIndex="999"
                borderWidth="1px"
                borderRadius="md"
                boxShadow="lg"
                maxH="300px"
                overflowY="auto"
                p={2}
              >
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => {
                    const status = getInvitationStatus(user);
                    console.log("sss", status);
                    return (
                      <HStack
                        key={user._id}
                        justify="space-between"
                        p={2}
                        borderBottom="1px solid #EDF2F7"
                      >
                        <HStack>
                          <Avatar
                            size="sm"
                            src={`https://develop-project-360.onrender.com/${user.path}`}
                          />
                          <Text>{user.sudo_name}</Text>
                        </HStack>

                        {status === "accepted" ? (
                          <Badge colorScheme="green" fontSize="xs">
                            Friends
                          </Badge>
                        ) : status === "pending" ? (
                          <Badge colorScheme="orange" fontSize="xs">
                            Pending
                          </Badge>
                        ) : status === "respond" ? (
                          <HStack>
                            <Button
                              size="xs"
                              colorScheme="green"
                              onClick={() => handleAcceptInvitation(user._id)}
                            >
                              Accept
                            </Button>
                            <Button
                              size="xs"
                              colorScheme="red"
                              onClick={() => handleRejectInvitation(user._id)}
                            >
                              Reject
                            </Button>
                          </HStack>
                        ) : status === "rejected" ? (
                          <Button
                            size="xs"
                            colorScheme="blue"
                            onClick={() => handleInvite(user._id)}
                          >
                            Re-invite
                          </Button>
                        ) : (
                          <Button
                            size="xs"
                            colorScheme="blue"
                            onClick={() => handleInvite(user._id)}
                          >
                            Invite
                          </Button>
                        )}
                      </HStack>
                    );
                  })
                ) : (
                  <Text textAlign="center" color="gray.500" fontSize="sm">
                    No users found.
                  </Text>
                )}
              </Box>
            )}
          </Box>
        </Flex>
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Create a New Group</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <form id="create-group-form" onSubmit={handleSubmit(onSubmit)}>
                <FormControl mb={4} isRequired>
                  <FormLabel textAlign="center">Group Icon</FormLabel>
                  <Flex justify="center">
                    <Box
                      as="label"
                      cursor="pointer"
                      borderRadius="full"
                      overflow="hidden"
                      w="100px"
                      h="100px"
                      border="2px dashed #ccc"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      position="relative"
                      _hover={{ borderColor: "blue.400" }}
                    >
                      {preview ? (
                        <Image
                          src={preview}
                          alt="Group Preview"
                          objectFit="cover"
                          w="100%"
                          h="100%"
                        />
                      ) : (
                        <Text
                          fontSize="xs"
                          color="gray.500"
                          textAlign="center"
                          px={2}
                        >
                          + Group Icon
                        </Text>
                      )}
                      <Input
                        type="file"
                        accept="image/*"
                        {...register("files")}
                        onChange={handleFiles}
                        display="none"
                        required={false}
                      />
                    </Box>
                  </Flex>
                </FormControl>

                <FormControl mb={4} isRequired>
                  <FormLabel>Group Name</FormLabel>
                  <Input placeholder="Group Name" {...register("name")} />
                </FormControl>

                <FormControl mb={4}>
                  <FormLabel>Select Members</FormLabel>
                  <VStack align="start" maxH="200px" overflowY="auto">
                    {users.map((user) => (
                      <Checkbox
                        key={user._id}
                        isChecked={selectedUsers.includes(user._id)}
                        onChange={() => handleUserToggle(user._id)}
                      >
                        {user.sudo_name || "Unnamed User"}
                      </Checkbox>
                    ))}
                  </VStack>
                </FormControl>
              </form>
            </ModalBody>

            <ModalFooter>
              <Button colorScheme="blue" type="submit" form="create-group-form">
                Create
              </Button>
              <Button onClick={onClose} ml={3}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Flex gap={4}>
          {/* Left: Chat list */}
          <Box
            w="25%"
            h="700px"
            overflowY="auto"
            p={3}
            borderRadius="lg"
            //border="1px solid gray"
            boxShadow="2xl"
          >
            {chatList.map((chat) => (
              <Box
                key={chat.id}
                p={3}
                mb={2}
                borderRadius="md"
                bg={selectedChat?.id === chat.id ? "green.100" : "gray.100"}
                cursor="pointer"
                onClick={() => handleChatSelect(chat)}
                _hover={{ bg: "gray.200" }}
              >
                <Flex align="center" gap={3}>
                  <Box position="relative">
                    <Avatar
                      name={chat.name}
                      size="md"
                      src={`https://develop-project-360.onrender.com/${chat.path}`}
                    />
                    <Box
                      position="absolute"
                      bottom="0"
                      right="0"
                      boxSize="10px"
                      borderRadius="full"
                      bg={getUserStatusColor(chat.id)}
                      border="2px solid white"
                    />
                  </Box>
                  <Box ml={1} flex="1" overflow="hidden">
                    <Text fontWeight="bold" fontSize="sm" textAlign={"start"}>
                      {chat.name}
                    </Text>
                    <Text
                      fontSize="sm"
                      color="gray.500"
                      textAlign="start"
                      isTruncated
                    >
                      {chat.lastMessage}
                    </Text>

                    {/* <Text fontSize="sm" color="gray.500" textAlign={"start"}>
                      {chat.isGroup ? "Group" : "Private"}
                    </Text> */}
                  </Box>
                </Flex>
                <Text fontSize="2xs" color="black.500" textAlign="end">
                  {isToday(parseISO(chat?.lastMessageAt))
                    ? format(parseISO(chat?.lastMessageAt), "HH:mm")
                    : format(parseISO(chat?.lastMessageAt), "dd-MM-yyyy")}
                </Text>
              </Box>
            ))}
          </Box>

          {/* Right: Chat area */}
          <Box
            w="75%"
            h="700px"
            p={4}
            borderRadius="lg"
            boxShadow="2xl"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            {/* Chat Messages */}
            <Box flex="1" overflowY="auto">
              <HStack
                spacing={1}
                mb={1}
                p={1}
                borderBottom="1px solid #CBD5E0"
                bg="white"
                position="sticky"
                top="0"
                zIndex="10"
              >
                <Flex w="100%" justifyContent={"space-between"}>
                  <Flex justifyContent={"flex-start"} gap={3}>
                    <Avatar
                      name={selectedChat?.name}
                      size="sm"
                      src={`https://develop-project-360.onrender.com/${selectedChat?.path}`}
                    />
                    <Text fontWeight="bold" fontSize="sm" textAlign={"start"}>
                      {selectedChat?.name}
                    </Text>
                  </Flex>

                  <Menu>
                    <MenuButton
                      as={IconButton}
                      icon={<FiMoreVertical />}
                      variant="ghost"
                      onClick={(e) => e.stopPropagation()} // prevent chat select
                    />
                    <MenuList>
                      {selectedChat?.isGroup && (
                        <>
                          <MenuItem
                            onClick={() => handleViewDetails(selectedChat)}
                          >
                            View Details
                          </MenuItem>
                          {/* <MenuItem
                            onClick={() => handleDeleteGroup(selectedChat.id)}
                          >
                            Delete Group
                          </MenuItem> */}
                          <Popover placement="top">
                            <PopoverTrigger>
                              <Button
                                colorScheme="red"
                                variant="ghost"
                                size={"xs"}
                              >
                                Delete Group
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader>Confirm Deletion</PopoverHeader>
                              <PopoverBody>
                                Are you sure you want to delete this group?
                              </PopoverBody>
                              <PopoverFooter
                                display="flex"
                                justifyContent="flex-end"
                              >
                                <Button
                                  size="xs"
                                  colorScheme="red"
                                  onClick={() =>
                                    handleDeleteGroup(selectedChat.id)
                                  }
                                >
                                  Yes, Delete
                                </Button>
                              </PopoverFooter>
                            </PopoverContent>
                          </Popover>
                        </>
                      )}

                      {/* Add more actions here if needed */}
                    </MenuList>
                  </Menu>
                  <Modal
                    isOpen={groupModal}
                    onClose={() => setGroupModal(false)}
                    size="lg"
                  >
                    <ModalOverlay />
                    <ModalContent>
                      <ModalHeader>Group Details</ModalHeader>
                      <ModalCloseButton />
                      <ModalBody>
                        <Text fontWeight="bold" mb={2}>
                          Members
                        </Text>
                        <VStack
                          align="start"
                          spacing={3}
                          mb={4}
                          maxH="300px"
                          overflowY="auto"
                        >
                          {selectedChat?.members?.map((memberId) => {
                            const member = getUserDetails(
                              memberId._id || memberId
                            );
                            if (!member) return null;

                            const isAdmin = member._id === selectedChat.admin;
                            const isCurrentUserAdmin =
                              userId === selectedChat.admin;

                            return (
                              <HStack
                                key={member._id}
                                justify="space-between"
                                width="100%"
                              >
                                <Flex align="center" gap={3}>
                                  <Avatar
                                    src={`https://develop-project-360.onrender.com/uploads/${member.name}`}
                                    name={member.sudo_name}
                                  />
                                  <Text>{member.sudo_name}</Text>
                                </Flex>

                                {isAdmin ? (
                                  <Button
                                    size="xs"
                                    colorScheme="green"
                                    variant="outline"
                                    isDisabled
                                  >
                                    Admin
                                  </Button>
                                ) : isCurrentUserAdmin ? (
                                  <Popover placement="left">
                                    <PopoverTrigger>
                                      <Button
                                        size="xs"
                                        colorScheme="red"
                                        variant="outline"
                                      >
                                        Remove
                                      </Button>
                                    </PopoverTrigger>
                                    <PopoverContent>
                                      <PopoverArrow />
                                      <PopoverCloseButton />
                                      <PopoverHeader>
                                        Confirm Removal
                                      </PopoverHeader>
                                      <PopoverBody>
                                        Are you sure you want to remove{" "}
                                        {member.sudo_name}?
                                      </PopoverBody>
                                      <PopoverFooter
                                        display="flex"
                                        justifyContent="flex-end"
                                      >
                                        <Button
                                          size="xs"
                                          colorScheme="red"
                                          onClick={() =>
                                            handleRemoveMember(member._id)
                                          }
                                        >
                                          Yes, Remove
                                        </Button>
                                      </PopoverFooter>
                                    </PopoverContent>
                                  </Popover>
                                ) : null}
                              </HStack>
                            );
                          })}
                        </VStack>
                        {userId === selectedChat?.admin && (
                          <FormControl mb={4}>
                            <FormLabel>Add Members</FormLabel>
                            <VStack align="start" maxH="100px" overflowY="auto">
                              {users
                                .filter(
                                  (user) =>
                                    !selectedChat.members.some(
                                      (m) => (m._id || m) === user._id
                                    )
                                )
                                .map((user) => {
                                  const isChecked = selectedNewMembers.includes(
                                    user._id
                                  );

                                  return (
                                    <Checkbox
                                      key={user._id}
                                      isChecked={isChecked}
                                      onChange={() =>
                                        handleUserToggleForNewMembers(user._id)
                                      }
                                    >
                                      {user.sudo_name || "Unnamed User"}
                                    </Checkbox>
                                  );
                                })}
                            </VStack>

                            {selectedNewMembers.length > 0 && (
                              <Button
                                size="sm"
                                colorScheme="blue"
                                mt={3}
                                onClick={handleAddMembers}
                                alignSelf="flex-start"
                              >
                                Add Selected Members
                              </Button>
                            )}
                          </FormControl>
                        )}

                        <Text fontWeight="bold" mb={2}>
                          Shared Files
                        </Text>
                        <Box overflowX="auto" whiteSpace="nowrap">
                          <HStack spacing={4}>
                            {selectedChat?.messages?.flatMap((msg) =>
                              msg.files?.map((file, idx) => {
                                const isImage = /\.(jpg|jpeg|png|gif)$/i.test(
                                  file.name
                                );
                                return (
                                  <Box
                                    key={`${file.path}-${idx}`}
                                    minW="150px"
                                    p={2}
                                    border="1px solid"
                                    borderColor="gray.200"
                                    borderRadius="md"
                                  >
                                    {isImage ? (
                                      <Image
                                        src={getImageUrl(file.path)}
                                        alt={file.name}
                                        boxSize="100px"
                                        objectFit="cover"
                                        mb={2}
                                      />
                                    ) : (
                                      <Text fontSize="sm" noOfLines={2}>
                                        {file.name}
                                      </Text>
                                    )}
                                    <Link
                                      href={getFileUrl(file.path)}
                                      isExternal
                                      fontSize="sm"
                                      color="blue.500"
                                    >
                                      View
                                    </Link>
                                  </Box>
                                );
                              })
                            )}
                          </HStack>
                        </Box>
                      </ModalBody>

                      <ModalFooter>
                        <Button onClick={() => setGroupModal(false)} ml={3}>
                          Close
                        </Button>
                      </ModalFooter>
                    </ModalContent>
                  </Modal>
                </Flex>
              </HStack>
              {selectedChat ? (
                <VStack spacing={3} maxH="600px" w="100%">
                  {messages?.length > 0 ? (
                    messages
                      ?.slice()
                      .reverse()
                      .map((msg, i) => {
                        const isSender =
                          (msg.sender?._id || msg.sender) === userId;

                        return (
                          <Flex
                            key={i}
                            w="100%"
                            justifyContent={
                              isSender ? "flex-end" : "flex-start"
                            }
                          >
                            <Box
                              position="relative"
                              p={3}
                              bg={isSender ? "green.200" : "gray.200"}
                              borderRadius="lg"
                              maxW="75%"
                              textAlign={isSender ? "right" : "left"}
                            >
                              {/* Three-dot menu visible only to the sender */}
                              {isSender && (
                                <Box position="absolute" top={1} right={1}>
                                  <Popover placement="bottom">
                                    <PopoverTrigger>
                                      <IconButton
                                        aria-label="Delete message"
                                        icon={<FiTrash2 />}
                                        size="xs"
                                        colorScheme="red"
                                        variant="ghost"
                                      />
                                    </PopoverTrigger>
                                    <PopoverContent>
                                      <PopoverArrow />
                                      <PopoverCloseButton />
                                      <PopoverHeader>
                                        Confirm Delete
                                      </PopoverHeader>
                                      <PopoverBody>
                                        Are you sure you want to delete this
                                        message?
                                      </PopoverBody>
                                      <PopoverFooter
                                        display="flex"
                                        justifyContent="flex-end"
                                      >
                                        <Button
                                          size="xs"
                                          colorScheme="red"
                                          onClick={() =>
                                            handleDeleteMessage(msg._id)
                                          }
                                        >
                                          Yes, Delete
                                        </Button>
                                      </PopoverFooter>
                                    </PopoverContent>
                                  </Popover>
                                </Box>
                              )}

                              <Text
                                fontSize="sm"
                                fontWeight="bold"
                                textAlign={"start"}
                              >
                                {typeof msg.sender === "object"
                                  ? msg.sender.sudo_name
                                  : globalState.sudo_name || msg.sender}
                              </Text>
                              <Text fontSize="md" wordBreak="break-word">
                                {msg.text ? msg.text : msg.message}
                              </Text>

                              {msg.files?.length > 0 && (
                                <VStack mt={2} spacing={1} align="start">
                                  {msg.files.map((file, idx) => {
                                    const isImage =
                                      /\.(png|jpg|jpeg|gif|webp)$/i.test(
                                        file.name
                                      );
                                    return isImage ? (
                                      <Image
                                        key={idx}
                                        src={`https://develop-project-360.onrender.com/${file.path}`}
                                        alt={file.name}
                                        maxW="150px"
                                        borderRadius="md"
                                        boxShadow="md"
                                      />
                                    ) : (
                                      <a
                                        key={idx}
                                        href={`https://develop-project-360.onrender.com/${file.path}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: "blue",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {file.name}
                                      </a>
                                    );
                                  })}
                                </VStack>
                              )}

                              <Text
                                fontSize="2xs"
                                color="black.500"
                                textAlign="end"
                              >
                                {msg?.createdAt &&
                                isValid(parseISO(msg?.createdAt))
                                  ? isToday(parseISO(msg?.createdAt))
                                    ? format(parseISO(msg?.createdAt), "HH:mm")
                                    : format(
                                        parseISO(msg?.createdAt),
                                        "dd-MM-yyyy, HH:mm"
                                      )
                                  : ""}
                              </Text>
                            </Box>
                          </Flex>
                        );
                      })
                  ) : (
                    <Flex
                      w="100%"
                      h="100%"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Text color="gray.500" textAlign="center">
                        No messages in this chat yet.
                      </Text>
                    </Flex>
                  )}
                  <Box ref={bottomRef} />
                </VStack>
              ) : (
                <Flex
                  h="100%"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                  textAlign="center"
                  borderRadius="lg"
                >
                  <Image
                    src={chatlogo}
                    alt="Start Chatting Illustration"
                    boxSize="350px"
                    objectFit="contain"
                    mb={4}
                    boxShadow="2xl"
                    borderRadius={50}
                  />
                </Flex>
              )}
            </Box>

            {/* Message Input */}
            {selectedFiles.length > 0 && (
              <HStack
                spacing={2}
                mb={2}
                overflowX="auto"
                w="100%"
                p={2}
                border="1px solid #CBD5E0"
                borderRadius="md"
                bg="gray.50"
              >
                {selectedFiles.map((file, index) => {
                  const isImage = file.type.startsWith("image/");

                  return (
                    <Box
                      key={index}
                      position="relative"
                      p={2}
                      bg="white"
                      borderRadius="md"
                      border="1px solid"
                      borderColor="gray.300"
                      minW="150px"
                    >
                      <IconButton
                        icon={<FiX />}
                        size="xs"
                        position="absolute"
                        top="0"
                        right="0"
                        onClick={() => removeFile(index)}
                        aria-label="Remove file"
                        variant="ghost"
                        colorScheme="red"
                      />
                      {isImage ? (
                        <img
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                          style={{
                            width: "100%",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "6px",
                          }}
                        />
                      ) : (
                        <Text fontSize="sm" isTruncated>
                          {file.name}
                        </Text>
                      )}
                    </Box>
                  );
                })}
              </HStack>
            )}

            {selectedChat && (
              <Flex mt={2} align="center" gap={2} w="100%">
                <InputGroup size="md" flex="1">
                  <Input
                    placeholder="Type your message..."
                    value={newMsg}
                    onChange={(e) => setNewMsg(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
                    pr="4.5rem"
                  />
                  <InputLeftElement width="3rem">
                    <IconButton
                      aria-label="Attach File"
                      icon={<FiPaperclip />}
                      variant="ghost"
                      as="label"
                      htmlFor="file-upload"
                      cursor="pointer"
                    />
                    <input
                      type="file"
                      id="file-upload"
                      style={{ display: "none" }}
                      multiple
                      onChange={handleFileChange}
                    />
                  </InputLeftElement>
                </InputGroup>

                <Button colorScheme="green" onClick={handleSendMessage}>
                  Send
                </Button>
              </Flex>
            )}
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default AdminChat;
